import React from 'react'
import { ReactFC } from '@frontend/utils/react-compat'
import { InView, useInView } from 'react-intersection-observer'

type Props = {
  className?: string
  as: React.ElementType<any>
  isFadeReverse?: boolean
} & React.ComponentPropsWithoutRef<typeof InView>

export const InViewFadeIn: ReactFC<
  Props & Omit<React.ComponentPropsWithRef<Props['as']>, keyof Props>
> = ({
  className,
  as: As = 'div',
  triggerOnce,
  rootMargin = '0px',
  delay,
  children,
  initialInView,
  isFadeReverse = false,
  ...rest
}) => {
  const [isFade, setIsFade] = React.useState(false)
  const { ref, inView } = useInView({
    triggerOnce,
    rootMargin: `8000px 0px ${rootMargin} 0px`,
  })

  React.useEffect(() => {
    if (inView) {
      setTimeout(() => {
        setIsFade(true)
      }, delay)
    }
  }, [inView, isFadeReverse])

  return (
    <As
      ref={ref}
      className={`${className} InviewObj${isFade ? ' fadein' : ''}`}
      {...rest}
    >
      {children}
    </As>
  )
}
